import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { MessageComponent } from "./message/message.component";
import { GlobalMessageComponent } from "./global-message/global-message.component";
import { ContractComponent } from "./contract/contract.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MapComponent } from "./map/map.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SuccessComponent } from "./success/success.component";
import { FaceOkComponent } from "./face-ok/face-ok.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";
import { ReactiveFormsModule } from "@angular/forms";
import { AlertBlockComponent } from "./alert-block/alert-block.component";
import { AlertSpinnerComponent } from "./alert-spinner/alert-spinner.component";
import { AlertPermissionsComponent } from "./alert-permissions/alert-permissions.component";
import { AlertComponent } from './alert/alert.component';
import { AlertTimedComponent } from './alert-timed/alert-timed.component';
import { AlertErrorFacelivenessComponent } from './alert-error-faceliveness/alert-error-faceliveness.component';

@NgModule({
  declarations: [
    MessageComponent,
    GlobalMessageComponent,
    ContractComponent,
    MapComponent,
    SuccessComponent,
    FaceOkComponent,
    AlertBlockComponent,
    AlertSpinnerComponent,
    AlertPermissionsComponent,
    AlertComponent,
    AlertTimedComponent,
    AlertErrorFacelivenessComponent,
  ],
  exports: [
    MessageComponent,
    GlobalMessageComponent,
    ContractComponent,
    MapComponent,
    SuccessComponent,
    FaceOkComponent,
    AlertComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    ScrollingModule,
    MatCheckboxModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
})
export class PartialsModule {}
